export const IconBlocked20: {
  name: 'icon_blocked_20-ab0880d46ee7'
} = {
  name: 'icon_blocked_20-ab0880d46ee7'
}
